import { normalize } from "normalizr";
import map from 'lodash/map';
import merge from "lodash/merge";

import { getEndpoint, getHeaders } from "../../../helpers/endpoint";
import { receiveEntities } from "../../entities";
import { weekListSchema } from "../../../schemas/week";
import {cardListSchema} from "../../../schemas/card";

export const GET_MPT_WEEKS = 'GET_MPT_WEEKS';
export const GET_MPT_WEEKS_SUCCESS = 'GET_MPT_WEEKS_SUCCESS';
export const GET_MPT_WEEKS_ERROR = 'GET_MPT_WEEKS_ERROR';

export const getMptWeeks = (scope) => {
    return (dispatch, getState) => {
        dispatch({ type: GET_MPT_WEEKS, scope });

        fetch(getEndpoint('getMptWeeks'), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: GET_MPT_WEEKS_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successGetMptWeeks(data, scope));
        })
            .catch((error, type = GET_MPT_WEEKS_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successGetMptWeeks(response, scope) {
    return dispatch => {
        const normalized = normalize(response.data.weeks, weekListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: GET_MPT_WEEKS_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: normalized.result,
            scope
        });
    };
}

export const EDIT_MPT_WEEK = 'EDIT_MPT_WEEK';
export const EDIT_MPT_WEEK_SUCCESS = 'EDIT_MPT_WEEK_SUCCESS';
export const EDIT_MPT_WEEK_ERROR = 'EDIT_MPT_WEEK_ERROR';

export const editMptWeek = (payload, weekId, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: EDIT_MPT_WEEK, payload, scope });
        fetch(getEndpoint('editMptWeek', weekId), {
            method: 'PATCH',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: EDIT_MPT_WEEK_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successEditMptWeek(data, getState(), weekId, scope));
        })
            .catch((error, type = EDIT_MPT_WEEK_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successEditMptWeek(response, state, weekId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.weeks, {
            [weekId]: {
                ...response.data,
            }
        });
        const normalized = normalize(responseToNormalized, weekListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: EDIT_MPT_WEEK_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: normalized.result,
            scope
        });
    };
}

export const EDIT_MPT_CARD = 'EDIT_MPT_CARD';
export const EDIT_MPT_CARD_SUCCESS = 'EDIT_MPT_CARD_SUCCESS';
export const EDIT_MPT_CARD_ERROR = 'EDIT_MPT_CARD_ERROR';

export const editMptCard = (payload, weekId, cardId, scope) => {
    return (dispatch, getState) => {
        const { lastname, file } = payload;
        let formData = new FormData();
        if (lastname) formData.append('lastname', lastname);
        if (file) formData.append('file', file);
        dispatch({ type: EDIT_MPT_CARD, scope });
        fetch(getEndpoint('editMptCard',{ weekId, cardId }),  {
            method: 'PATCH',
            headers: getHeaders(getState().authentication),
            body: formData,
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: EDIT_MPT_CARD_ERROR,
                error: data.error,
                payload,
                scope
            });
            else dispatch(successEditMptCard(data, getState(), cardId, scope));
        })
            .catch((error, type = EDIT_MPT_CARD_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successEditMptCard(response, state, cardId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.cards, {
            [cardId]: {
                ...response.data,
            }
        });
        console.log(responseToNormalized);
        const normalized = normalize(responseToNormalized, cardListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: EDIT_MPT_CARD_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.app.mpt.weeks.ids,
            scope
        });
    };
}

export const EDIT_MPT_DESTINATION = 'EDIT_MPT_DESTINATION';
export const EDIT_MPT_DESTINATION_SUCCESS = 'EDIT_MPT_DESTINATION_SUCCESS';
export const EDIT_MPT_DESTINATION_ERROR = 'EDIT_MPT_DESTINATION_ERROR';

export const editMptDestination = (payload, weekId, cardId, dest, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: EDIT_MPT_DESTINATION, payload, scope });
        fetch(getEndpoint('editMptDestination', { cardId, dest }), {
            method: 'PATCH',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: EDIT_MPT_DESTINATION_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successEditMptDestination(data, getState(), weekId, cardId, scope));
        })
            .catch((error, type = EDIT_MPT_DESTINATION_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successEditMptDestination(response, state, weekId, cardId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.cards, {
            [cardId]: {
                destinations: {
                    [response.data.id]: response.data,
                }
            }
        });
        const normalized = normalize(responseToNormalized, cardListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: EDIT_MPT_DESTINATION_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.app.mpt.weeks.ids,
            scope
        });
    };
}

export const POST_MPT_DESTINATION = 'POST_MPT_DESTINATION';
export const POST_MPT_DESTINATION_SUCCESS = 'POST_MPT_DESTINATION_SUCCESS';
export const POST_MPT_DESTINATION_ERROR = 'POST_MPT_DESTINATION_ERROR';

export const postMptDestination = (payload, weekId, cardId, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: POST_MPT_DESTINATION, payload, scope });
        fetch(getEndpoint('postMptDestination', { cardId }), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: POST_MPT_DESTINATION_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successPostMptDestination(data, getState(), cardId, scope));
        })
            .catch((error, type = POST_MPT_DESTINATION_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPostMptDestination(response, state, cardId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.cards, {
            [cardId]: {
                destinations: {
                    [response.data.id]: response.data,
                }
            }
        });
        const normalized = normalize(responseToNormalized, cardListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: POST_MPT_DESTINATION_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.app.mpt.weeks.ids,
            scope,
        });
    };
}

export const POST_MPT_DESTINATION_D0 = 'POST_MPT_DESTINATION_D0';
export const POST_MPT_DESTINATION_D0_SUCCESS = 'POST_MPT_DESTINATION_D0_SUCCESS';
export const POST_MPT_DESTINATION_D0_ERROR = 'POST_MPT_DESTINATION_D0_ERROR';

export const postMptDestinationD0 = (payload, weekId, cardId, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: POST_MPT_DESTINATION_D0, payload, scope });
        fetch(getEndpoint('postMptDestinationD0', { cardId }), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: POST_MPT_DESTINATION_D0_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successPostMptDestinationD0(data, getState(), cardId, scope));
        })
            .catch((error, type = POST_MPT_DESTINATION_D0_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPostMptDestinationD0(response, state, cardId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.cards, {
            [cardId]: {
                destinations: {
                    [response.data.id]: response.data,
                }
            }
        });
        const normalized = normalize(responseToNormalized, cardListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: POST_MPT_DESTINATION_D0_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.app.mpt.weeks.ids,
            scope
        });
    };
}

export const POST_MPT_DESTINATION_D6 = 'POST_MPT_DESTINATION_D6';
export const POST_MPT_DESTINATION_D6_SUCCESS = 'POST_MPT_DESTINATION_D6_SUCCESS';
export const POST_MPT_DESTINATION_D6_ERROR = 'POST_MPT_DESTINATION_D6_ERROR';

export const postMptDestinationD6 = (payload, weekId, cardId, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: POST_MPT_DESTINATION_D6, payload, scope });
        fetch(getEndpoint('postMptDestinationD6', { cardId }), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: POST_MPT_DESTINATION_D6_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successPostMptDestinationD6(data, getState(), cardId, scope));
        })
            .catch((error, type = POST_MPT_DESTINATION_D6_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPostMptDestinationD6(response, state, cardId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.cards, {
            [cardId]: {
                destinations: {
                    [response.data.id]: response.data,
                }
            }
        });
        const normalized = normalize(responseToNormalized, cardListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: POST_MPT_DESTINATION_D6_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.app.mpt.weeks.ids,
            scope
        });
    };
}

export const POST_MPT_WEEK = 'POST_MPT_WEEK';
export const POST_MPT_WEEK_SUCCESS = 'POST_MPT_WEEK_SUCCESS';
export const POST_MPT_WEEK_ERROR = 'POST_MPT_WEEK_ERROR';

export const postMptWeek = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: POST_MPT_WEEK, payload, scope });
        fetch(getEndpoint('postMptWeek'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: POST_MPT_WEEK_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successPostMptWeek(data, getState(), scope));
        })
            .catch((error, type = POST_MPT_WEEK_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPostMptWeek(response, state, scope) {
    return dispatch => {
        const responseToNormalized = {
                ...state.entities.weeks,
            [response.data.id]: response.data,
        };
        const ids = state.app.mpt.weeks.ids;
        if (state.app.mpt.weeks.ids.length) {
            ids.push(state.app.mpt.weeks.ids.length + 1);
        } else {
            ids.push(1);
        }
        const normalized = normalize(responseToNormalized, weekListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: POST_MPT_WEEK_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: ids,
            scope
        });
    };
}

export const POST_MPT_CARD = 'POST_MPT_CARD';
export const POST_MPT_CARD_SUCCESS = 'POST_MPT_CARD_SUCCESS';
export const POST_MPT_CARD_ERROR = 'POST_MPT_CARD_ERROR';

export const postMptCard = (payload, weekId, scope) => {
    return (dispatch, getState) => {
        const { lastname, file } = payload;
        let formData = new FormData();
        formData.append('lastname', lastname);
        formData.append('file', file);
        dispatch({ type: POST_MPT_CARD, scope });
        fetch(getEndpoint('postMptCard', weekId),  {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: formData,
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: POST_MPT_CARD_ERROR,
                error: data.error,
                payload,
                scope
            });
            else dispatch(successPostMptCard(data, getState(), weekId, scope));
        })
            .catch((error, type = POST_MPT_CARD_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPostMptCard(response, state, weekId, scope) {
    return dispatch => {
        const responseToNormalizedCard = {
            ...state.entities.cards,
            [response.data.id]: response.data,
        };
        const normalizedCard = normalize(responseToNormalizedCard, cardListSchema);
        dispatch(receiveEntities(normalizedCard.entities));
        const responseToNormalizedWeek = map(state.entities.weeks, week => {
            if (weekId === week.id) {
                const id = week.cards.length ? week.cards.length + 1 : 1;
                return {
                    ...week,
                    cards: {
                        ...week.cards,
                        [id]: response.data.id,
                    }
                }
            }
            return {
                ...week,
            }
        });
        const normalized = normalize(responseToNormalizedWeek, weekListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: POST_MPT_CARD_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.app.mpt.weeks.ids,
            scope
        });
    };
}

export const PUBLISH_MPT = 'PUBLISH_MPT';
export const PUBLISH_MPT_SUCCESS = 'PUBLISH_MPT_SUCCESS';
export const PUBLISH_MPT_ERROR = 'PUBLISH_MPT_ERROR';

export const publishMpt = (scope) => {
    return (dispatch, getState) => {
        dispatch({ type: PUBLISH_MPT, scope });

        fetch(getEndpoint('publishMPT'), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: PUBLISH_MPT_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successPublishMpt(data, scope));
        })
            .catch((error, type = PUBLISH_MPT_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successPublishMpt(response, scope) {
    return dispatch => {

        dispatch({
            type: PUBLISH_MPT_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            response,
            scope
        });
    };
}

export const VALIDATE_TRANSFERT = 'VALIDATE_TRANSFERT';
export const VALIDATE_TRANSFERT_SUCCESS = 'VALIDATE_TRANSFERT_SUCCESS';
export const VALIDATE_TRANSFERT_ERROR = 'VALIDATE_TRANSFERT_ERROR';

export const validateTransfertMPT = (payload, weekId, cardId, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: VALIDATE_TRANSFERT, payload, scope });

        fetch(getEndpoint('validateTransfert', { weekId, cardId }), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: VALIDATE_TRANSFERT_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successValidateTransfertMPT(data, getState(), cardId,  scope));
        })
            .catch((error, type = VALIDATE_TRANSFERT_ERROR) => {dispatch({ type, error, scope });});
    };
};

function successValidateTransfertMPT(response, state, cardId, scope) {
    return dispatch => {
        const responseToNormalized = merge({}, state.entities.cards, {
            [cardId]: {
                valid: response.data,
            }
        });
        const normalized = normalize(responseToNormalized, cardListSchema);
        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: VALIDATE_TRANSFERT_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ids: state.entities.weeks,
            scope
        });
    };
}

export const START_CALCULATION = 'START_CALCULATION';
export const START_CALCULATION_SUCCESS = 'START_CALCULATION_SUCCESS';
export const START_CALCULATION_ERROR = 'START_CALCULATION_ERROR';

export const startCalculationMPT = (scope) => {
    return (dispatch, getState) => {
        dispatch({ type: START_CALCULATION, scope });

        fetch(getEndpoint('startCalculation'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: START_CALCULATION_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successStartCalculationMPT(data, scope));
        })
            .catch((error, type = START_CALCULATION_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successStartCalculationMPT(response, scope) {
    return dispatch => {
        dispatch({
            type: START_CALCULATION_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            scope
        });
    };
}

export const CHECK_RUNNING = 'CHECK_RUNNING';
export const CHECK_RUNNING_SUCCESS = 'CHECK_RUNNING_SUCCESS';
export const CHECK_RUNNING_ERROR = 'CHECK_RUNNING_ERROR';

export const checkRunningCalculation = (scope) => {
    return (dispatch, getState) => {
        dispatch({ type: CHECK_RUNNING, scope });

        fetch(getEndpoint('checkRunning'), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
            if(data.error) dispatch({
                type: CHECK_RUNNING_ERROR,
                error: data.error,
                scope
            });
            else dispatch(successCheckRunningCalculation(data, scope));
        })
            .catch((error, type = CHECK_RUNNING_ERROR) => { dispatch({ type, error, scope }); });
    };
};

function successCheckRunningCalculation(response, scope) {
    return dispatch => {
        dispatch({
            type: CHECK_RUNNING_SUCCESS,
            receivedAt: Date.now(),
            success: true,
            ...response,
            scope
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/entities/mpt/weeks.js